var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.648,
    height: 190.834,
    viewBox: "0 0 191.648 190.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2804",
    "data-name": "Group 2804",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742",
    transform: "translate(88.41 2.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M1640.324,408.953l-1.489-.877,3.474-5.9,5.667,2.944,1.923-12.98,9.183,11.418-1.347,1.083-6.706-8.338-1.7,11.468-6.364-3.306Z",
    transform: "translate(-1638.835 -392.137)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(179.992 182.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M1928.335,959.065A4.061,4.061,0,1,1,1932.4,955,4.066,4.066,0,0,1,1928.335,959.065Zm0-6.393a2.332,2.332,0,1,0,2.332,2.332A2.335,2.335,0,0,0,1928.335,952.672Z",
    transform: "translate(-1924.274 -950.943)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    transform: "translate(0 70.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M1367.98,614.842l-4.7-10.454,12.425,1.565Zm-1.858-8.355,2.327,5.181,3.829-4.4Z",
    transform: "translate(-1363.283 -604.387)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776",
    transform: "translate(0.978 25.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2473",
    "data-name": "Rectangle 2473",
    width: 38.583,
    height: 9.635,
    transform: "translate(68.899 28.962)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M1459.949,640.26a23.758,23.758,0,0,0-23.407-20.418v.119a23.921,23.921,0,0,0-23.669,20.3Z",
    transform: "translate(-1397.94 -569.97)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M1707.814,539.555l24.115,12.721-.285-58.01L1690.589,464.4v84.153Z",
    transform: "translate(-1586.552 -464.405)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M1674.853,721.167l27.585-14.659,26.382,14.659Z",
    transform: "translate(-1575.865 -628.83)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745",
    transform: "translate(8.782 69.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M1447.793,766.573H1393.7V680.788h54.091Zm-52.363-1.728h50.635V682.517h-50.635Z",
    transform: "translate(-1393.701 -680.788)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(8.782 43.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M1447.793,640.225h-1.728V628.576a25.317,25.317,0,0,0-50.635,0v7.516H1393.7v-7.516a27.046,27.046,0,1,1,54.091,0Z",
    transform: "translate(-1393.701 -601.53)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    transform: "translate(61.145 37.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M1615.129,614.565H1613.4V583.735h-54.769v14.293H1556.9V582.007h58.226Z",
    transform: "translate(-1556.904 -582.007)",
    fill: "#26313b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748",
    transform: "translate(68.035 22.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M1622.6,550.786h-1.728V536.492h-40.763v14.294h-1.729V534.764h44.22Z",
    transform: "translate(-1578.378 -534.764)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(88.704 91.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    "data-name": "Path 4200",
    d: "M1707.915,813.242H1642.8V749.5h65.115Zm-63.387-1.729h61.658V751.232h-61.658Z",
    transform: "translate(-1642.8 -749.504)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750",
    transform: "translate(0 153.482)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2474",
    "data-name": "Rectangle 2474",
    width: 159.845,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751",
    transform: "translate(19.292 163.128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2475",
    "data-name": "Rectangle 2475",
    width: 103.823,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(132.766 163.128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2476",
    "data-name": "Rectangle 2476",
    width: 7.778,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753",
    transform: "translate(107.996 136.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4201",
    "data-name": "Path 4201",
    d: "M1730.837,908.633h-1.728V892.961h-24.453v15.672h-1.728v-17.4h27.91Z",
    transform: "translate(-1702.927 -891.233)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754",
    transform: "translate(107.482 124.545)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2477",
    "data-name": "Rectangle 2477",
    width: 27.559,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(108.86 114.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    "data-name": "Path 4202",
    d: "M1730.972,824.245h-2.3v-1.728h2.3Zm-4.609,0h-2.3v-1.728h2.3Zm-4.609,0h-2.3v-1.728h2.3Zm-4.609,0h-2.3v-1.728h2.3Zm-4.609,0h-2.3v-1.728h2.3Zm-4.609,0h-2.3v-1.728h2.3Z",
    transform: "translate(-1705.621 -822.516)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    transform: "translate(107.482 105.253)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2478",
    "data-name": "Rectangle 2478",
    width: 27.559,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757",
    transform: "translate(120.398 137.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2479",
    "data-name": "Rectangle 2479",
    width: 1.728,
    height: 16.536,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758",
    transform: "translate(93.702 51.512)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2480",
    "data-name": "Rectangle 2480",
    width: 13.78,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    transform: "translate(73.033 51.512)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2481",
    "data-name": "Rectangle 2481",
    width: 12.402,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760",
    transform: "translate(93.702 63.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2482",
    "data-name": "Rectangle 2482",
    width: 13.78,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(73.033 63.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2483",
    "data-name": "Rectangle 2483",
    width: 12.402,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(93.702 74.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2484",
    "data-name": "Rectangle 2484",
    width: 13.78,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763",
    transform: "translate(73.033 74.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2485",
    "data-name": "Rectangle 2485",
    width: 12.402,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(72.169 88.204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2486",
    "data-name": "Rectangle 2486",
    width: 1.728,
    height: 49.607,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(85.034 74.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    "data-name": "Path 4203",
    d: "M1632.162,716.055l-.8-1.532,36.229-18.935,35.912,18.937-.806,1.529-35.109-18.514Z",
    transform: "translate(-1631.362 -695.588)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(2.458 139.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2487",
    "data-name": "Rectangle 2487",
    width: 1.728,
    height: 7.591,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(2.458 79.936)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2488",
    "data-name": "Rectangle 2488",
    width: 1.728,
    height: 50.985,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768",
    transform: "translate(88.704 1.391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2489",
    "data-name": "Rectangle 2489",
    width: 1.728,
    height: 18.304,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2775",
    "data-name": "Group 2775",
    transform: "translate(20.86 79.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    d: "M1442.1,728.383h-10.755V713.595H1442.1Zm-9.026-1.728h7.3V715.323h-7.3Z",
    transform: "translate(-1431.347 -713.595)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    transform: "translate(19.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    "data-name": "Path 4205",
    d: "M1501.879,728.383h-10.755V713.595h10.755Zm-9.027-1.728h7.3V715.323h-7.3Z",
    transform: "translate(-1491.124 -713.595)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771",
    transform: "translate(0 21.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    d: "M1442.1,794.654h-10.755V779.866H1442.1Zm-9.026-1.728h7.3V781.594h-7.3Z",
    transform: "translate(-1431.347 -779.866)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    transform: "translate(19.179 21.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    d: "M1501.879,794.654h-10.755V779.866h10.755Zm-9.027-1.728h7.3V781.594h-7.3Z",
    transform: "translate(-1491.124 -779.866)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2773",
    "data-name": "Group 2773",
    transform: "translate(0 42.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    "data-name": "Path 4208",
    d: "M1442.1,860.926h-10.755V846.138H1442.1Zm-9.026-1.728h7.3V847.866h-7.3Z",
    transform: "translate(-1431.347 -846.138)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2774",
    "data-name": "Group 2774",
    transform: "translate(19.179 42.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    "data-name": "Path 4209",
    d: "M1501.879,860.926h-10.755V846.138h10.755Zm-9.027-1.728h7.3V847.866h-7.3Z",
    transform: "translate(-1491.124 -846.138)",
    fill: "#033662"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2785",
    "data-name": "Group 2785",
    transform: "translate(116.86 4.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777",
    transform: "translate(65.156 11.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    "data-name": "Path 4210",
    d: "M1937.134,469.162h-6.551v-1.729h6.551a1.407,1.407,0,0,0,1.352-1.453V435.546a1.407,1.407,0,0,0-1.352-1.453h-6.551v-1.728h6.551a3.136,3.136,0,0,1,3.081,3.181V465.98A3.136,3.136,0,0,1,1937.134,469.162Z",
    transform: "translate(-1930.583 -432.365)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2778",
    "data-name": "Group 2778",
    transform: "translate(65.156 20.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4211",
    "data-name": "Path 4211",
    d: "M1940.214,470.185h-9.631v-1.729h7.9v-7.039h-7.9V459.69h9.631Z",
    transform: "translate(-1930.583 -459.69)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2779",
    "data-name": "Group 2779",
    transform: "translate(65.156 37.991)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2490",
    "data-name": "Rectangle 2490",
    width: 8.767,
    height: 1.728,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M1793.527,476.564h-31.549v-1.728H1791.8V397.66h-56.075c-3.137,0-6.488,1.669-6.488,6.354v17.622h-1.729V404.015c0-4.91,3.226-8.083,8.217-8.083h57.8Z",
    transform: "translate(-1727.507 -395.932)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(17.534 11.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M1813.459,445.783h-28.73a2.575,2.575,0,0,1-2.572-2.573v-8.273a2.575,2.575,0,0,1,2.572-2.572h28.73a2.575,2.575,0,0,1,2.572,2.572v8.273A2.575,2.575,0,0,1,1813.459,445.783Zm-28.73-11.689a.845.845,0,0,0-.844.844v8.273a.845.845,0,0,0,.844.844h28.73a.845.845,0,0,0,.844-.844v-8.273a.845.845,0,0,0-.844-.844Z",
    transform: "translate(-1782.157 -432.365)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782",
    transform: "translate(8.767 0.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2491",
    "data-name": "Rectangle 2491",
    width: 1.728,
    height: 31.438,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(34.472 66.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2492",
    "data-name": "Rectangle 2492",
    width: 30.685,
    height: 1.728,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2784",
    "data-name": "Group 2784",
    transform: "translate(34.472 72.483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2493",
    "data-name": "Rectangle 2493",
    width: 30.685,
    height: 1.728,
    fill: "#93ddff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794",
    transform: "translate(0.554 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2791",
    "data-name": "Group 2791",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2786",
    "data-name": "Group 2786",
    transform: "translate(0 35.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M1419.054,521.2h-46.725a7.325,7.325,0,0,1-7.316-7.316V494.26h1.729v19.623a5.594,5.594,0,0,0,5.588,5.588h46.725Z",
    transform: "translate(-1365.012 -494.26)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2787",
    "data-name": "Group 2787",
    transform: "translate(70.403 24.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2494",
    "data-name": "Rectangle 2494",
    width: 1.728,
    height: 15.822,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2788",
    "data-name": "Group 2788",
    transform: "translate(24.332 39.907)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2495",
    "data-name": "Rectangle 2495",
    width: 23.468,
    height: 1.728,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2789",
    "data-name": "Group 2789",
    transform: "translate(0 8.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    d: "M1423.667,440.6l-.85-1.5c.077-.044,7.721-4.367,10.06-6.04a6.714,6.714,0,0,0,2.538-5.535v-9.9a5.594,5.594,0,0,0-5.588-5.588h-57.5a5.594,5.594,0,0,0-5.588,5.588v9.44a6.987,6.987,0,0,0,3.17,5.863l9.477,6.2-.947,1.446-9.477-6.2a8.711,8.711,0,0,1-3.951-7.31v-9.44a7.325,7.325,0,0,1,7.316-7.316h57.5a7.325,7.325,0,0,1,7.316,7.316v9.9a8.434,8.434,0,0,1-3.261,6.941C1431.469,436.183,1423.985,440.416,1423.667,440.6Z",
    transform: "translate(-1365.012 -410.296)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2790",
    "data-name": "Group 2790",
    transform: "translate(18.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4216",
    "data-name": "Path 4216",
    d: "M1422.6,392.182l-1.308-1.13c4.118-4.767,10.966-7.612,18.319-7.612s14.2,2.846,18.319,7.612l-1.308,1.13c-3.793-4.392-10.152-7.014-17.011-7.014S1426.393,387.79,1422.6,392.182Z",
    transform: "translate(-1421.291 -383.44)",
    fill: "#033662"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2792",
    "data-name": "Group 2792",
    transform: "translate(12.937 35.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    "data-name": "Path 4217",
    d: "M1414.222,507.164h-5.616a3.275,3.275,0,0,1-3.271-3.271v-5.616a3.275,3.275,0,0,1,3.271-3.271h5.616a3.275,3.275,0,0,1,3.271,3.271v5.616A3.275,3.275,0,0,1,1414.222,507.164Zm-5.616-10.43a1.545,1.545,0,0,0-1.543,1.543v5.616a1.545,1.545,0,0,0,1.543,1.543h5.616a1.544,1.544,0,0,0,1.543-1.543v-5.616a1.544,1.544,0,0,0-1.543-1.543Z",
    transform: "translate(-1405.334 -495.005)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2793",
    "data-name": "Group 2793",
    transform: "translate(46.835 35.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M1519.873,507.164h-5.616a3.275,3.275,0,0,1-3.271-3.271v-5.616a3.275,3.275,0,0,1,3.271-3.271h5.616a3.275,3.275,0,0,1,3.271,3.271v5.616A3.275,3.275,0,0,1,1519.873,507.164Zm-5.616-10.43a1.545,1.545,0,0,0-1.543,1.543v5.616a1.545,1.545,0,0,0,1.543,1.543h5.616a1.544,1.544,0,0,0,1.542-1.543v-5.616a1.544,1.544,0,0,0-1.542-1.543Z",
    transform: "translate(-1510.985 -495.005)",
    fill: "#93ddff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2803",
    "data-name": "Group 2803",
    transform: "translate(151.331 92.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2798",
    "data-name": "Group 2798",
    transform: "translate(19.999 17.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795",
    transform: "translate(0 54.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M1904.73,904.9h-4.312a3.143,3.143,0,0,1-3.14-3.14v-5.643h10.59v5.643A3.143,3.143,0,0,1,1904.73,904.9Zm-5.723-7.054v3.915a1.413,1.413,0,0,0,1.411,1.411h4.312a1.413,1.413,0,0,0,1.411-1.411v-3.915Z",
    transform: "translate(-1897.279 -896.117)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796",
    transform: "translate(0 2.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M1899.008,783.451h-1.729V742.873l5.3-10.527,5.3,10.527V783.31h-1.728V743.283l-3.567-7.09-3.567,7.09Z",
    transform: "translate(-1897.279 -732.346)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797",
    transform: "translate(4.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2496",
    "data-name": "Rectangle 2496",
    width: 1.728,
    height: 5.476,
    fill: "#033662"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2799",
    "data-name": "Group 2799",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M1875.109,708.819h-7.536V707.09h5.808V672.122h-38.434v-1.728h40.163Z",
    transform: "translate(-1834.946 -670.393)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2800",
    "data-name": "Group 2800",
    transform: "translate(9.491 36.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2497",
    "data-name": "Rectangle 2497",
    width: 9.021,
    height: 1.728,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2801",
    "data-name": "Group 2801",
    transform: "translate(21.064 29.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2498",
    "data-name": "Rectangle 2498",
    width: 8.46,
    height: 1.728,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2802",
    "data-name": "Group 2802",
    transform: "translate(0 10.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M1860.3,705.543h-2.3v-1.729h2.3Zm-4.609,0h-2.3v-1.729h2.3Zm-4.609,0h-2.3v-1.729h2.3Zm-4.609,0h-2.3v-1.729h2.3Zm-4.609,0h-2.3v-1.729h2.3Zm-4.609,0h-2.3v-1.729h2.3Z",
    transform: "translate(-1834.946 -703.814)",
    fill: "#033662"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.d64a54dbd30afe20741b20ba213ee7cb.svg";
export { ForwardRef as ReactComponent };